import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import BrandMark from "../../components/BrandMark";
import StatusChip from "../../components/StatusChip";
import { Card, CardContent } from "../../components/ui/card";
import { API } from "../../lib/api";
import { AlertTriangle, Phone } from "lucide-react";

export default function PublicPay() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    axios.get(`${API}/deposits/public/${token}`)
      .then((r) => setData(r.data))
      .catch(() => setErr("Deposit link not found or expired."));
  }, [token]);

  if (err) return <div className="min-h-screen bg-erf-dark text-erf-cream flex items-center justify-center p-6" data-testid="public-pay-error"><div className="text-center"><BrandMark size={80} /><div className="mt-4 text-erf-cream/70">{err}</div></div></div>;
  if (!data) return <div className="min-h-screen bg-erf-cream flex items-center justify-center font-mono text-xs text-erf-dark/60">Loading…</div>;

  const d = data.deposit, brand = data.brand || {}, contact = data.contact || {};
  const isDemo = d.provider === "internal_placeholder";

  return (
    <div className="min-h-screen bg-erf-cream text-erf-dark" data-testid="public-pay-page">
      <header className="bg-erf-dark text-erf-cream px-6 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3"><BrandMark size={48} /><div>
          <div className="font-display font-bold">{brand.display_name || "ERF Enterprises"}</div>
          <div className="text-[11px] font-mono uppercase tracking-widest text-erf-cream/50">Deposit Request</div>
        </div></div>
        <StatusChip status={d.status === "paid" ? "verified" : isDemo ? "externally_blocked" : "connecting"} label={d.status} />
      </header>

      <main className="max-w-2xl mx-auto p-6 space-y-6">
        <Card className="border-erf-gold/40">
          <CardContent className="p-6 space-y-3">
            <div className="text-[11px] font-mono uppercase tracking-widest text-erf-gold">Amount due</div>
            <div className="font-mono text-5xl font-bold" data-testid="public-pay-amount">${Number(d.amount).toLocaleString(undefined, { minimumFractionDigits: 2 })}</div>
            <div className="text-xs font-nav text-erf-dark/70">Contract {String(d.contract_id).slice(0,8)} · Due {d.due_by ? new Date(d.due_by).toLocaleDateString() : "on receipt"}</div>
          </CardContent>
        </Card>

        {isDemo && (
          <Card className="border-amber-200 bg-amber-50">
            <CardContent className="p-5 space-y-4">
              <div className="flex items-start gap-2 text-amber-900">
                <AlertTriangle className="w-5 h-5 mt-0.5" />
                <div>
                  <div className="font-display font-semibold">Online payments are not enabled</div>
                  <div className="text-sm font-nav mt-1">No payment can be made through this link. Please contact ERF Enterprises to arrange payment using the details below.</div>
                </div>
              </div>
              <div className="border-t border-amber-200 pt-3 grid gap-2 text-sm font-nav">
                {contact.phone_office && <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-amber-800" /> Office · {contact.phone_office}</div>}
                {contact.phone_mobile && <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-amber-800" /> Mobile · {contact.phone_mobile}</div>}
              </div>
            </CardContent>
          </Card>
        )}

        <div className="text-[11px] font-mono text-erf-dark/40 uppercase tracking-widest text-center pt-4 pb-8">
          ERF ENTERPRISES LLC · Your Project. Our Promise.
        </div>
      </main>
    </div>
  );
}
